import { useEffect } from 'react';
import { isAndroid, isMobile, isTablet } from 'react-device-detect';

export default function useAutoFocus(ref) {
  useEffect(() => {
    if (isTablet || !isMobile || isAndroid) return;
    if (ref && ref.current) {
      ref.current.focus();
      setTimeout(() => ref.current.blur(), 30);
    }
  }, [ref]);
}

